<ng-container *ngIf="!loadingVideoIPP; else loadingTemplate">
  <div class="container-informe">
    <button type="button" class="btn-back" fill="clear" (click)="goBack()">
      <ion-icon name="arrow-back-outline"></ion-icon>
      <span>Volver</span>
    </button>
    <app-card-header
      id="statusElement"
      [isValidateVideoIPP]="isValidateVideoIPP"
      [propiedadesVideo]="propiedadesVideo"
    ></app-card-header>

    <div class="contentArea">
      <div class="innerContainer">
        <div class="primaryContent">
          <ion-grid
            class="ion-no-padding"
            [ngClass]="showErrorScreen ? 'ion-hide' : ''"
          >
            <ion-row>
              <app-content-section id="statusElement1"></app-content-section>
            </ion-row>

            <ion-row>
              <h2 id="statusElement2" class="actions-title">
                ¿Qué puedes hacer con tu informe?
              </h2>
              <p class="actions-description">
                Al conocer el estado de tus ahorros y su impacto en tu pensión,
                podrás tomar decisiones con seguridad en los siguientes temas:
              </p>
              <app-actions-grid></app-actions-grid>
            </ion-row>
          </ion-grid>
        </div>
        <div class="secondaryContent" *ngIf="!showErrorScreen">
          <app-right-side-info-column
            [data]="rightColumnData"
            [isInterest]="true"
            (idRightColumnEmit)="idRightColumnEmit($event)"
          ></app-right-side-info-column>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <div class="container-informe-skeleton">
    <ion-skeleton-text
      animated
      style="width: 100%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>

    <ion-skeleton-text
      animated
      style="width: 80%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>

    <ion-skeleton-text
      animated
      style="width: 100%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>

    <ion-skeleton-text
      animated
      style="width: 70%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>

    <ion-skeleton-text
      animated
      style="width: 100%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>

    <ion-skeleton-text
            animated
            style="width: 90%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>
    <ion-skeleton-text
            animated
            style="width: 80%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>
    <ion-skeleton-text
            animated
            style="width: 90%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>
    <ion-skeleton-text
            animated
            style="width: 100%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>
    <ion-skeleton-text
            animated
            style="width: 90%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>
  </div>
</ng-template>
